import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* This function is scrolling every time at position (0,0) were the location is updated("/home", "/about", "/contact", "/faq") */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop